var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "product-offer-table uk-table uk-table-divider uk-table-justify"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th'), _vm._v(" "), _c('th', [_vm._v("\n        " + _vm._s(_vm.$t('fields.onetimePrice')) + "\n      ")]), _vm._v(" "), _c('th', [_vm._v("\n        " + _vm._s(_vm.$t('fields.monthlyPrice')) + "\n      ")]), _vm._v(" "), _c('th', [_vm._v("\n        " + _vm._s(_vm.$t('fields.tenants')) + "\n      ")]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.offers), function(offer) {
    return _c('product-offer-table-row', {
      key: offer.id,
      attrs: {
        "offer": offer
      }
    })
  }))])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-43ed2d94","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/ProductOfferTable.vue
// module id = 1964
// module chunks = 0